
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ReportShowConfigV5Item } from "@/lib/model/exam/result";
import { CandidateNewResult } from "@/lib/model/exam/candidate-result";

enum cheatEnum {
  "bgCheckIdentity" = "手机号实名认证",
  "bgCheckFinancial" = "综合B类评估记录",
  "bgCheckSocial" = "综合A类评估记录",
  "nameIdCheck" = "身份信息核验（二要素核验）"
}

const cheatKeys = [
  "bgCheckIdentity",
  "bgCheckFinancial",
  "bgCheckSocial",
  "nameIdCheck"
];

//异常项 默认文案
const errorEnumText = ["未检测", "未通过", "通过"];
//异常项 对应文案 详情用
const errorEnumTextEX = {
  bgCheckIdentity: ["手机号实名未查询", "手机号实名异常", "通过"],
  bgCheckFinancial: ["综合B类评估未检测", "综合B类评估异常", "通过"],
  bgCheckSocial: ["综合A类评估未检测", "综合A类评估异常", "通过"],
  nameIdCheck: [
    "身份信息验证（二要素核验）未检测",
    "身份信息验证（二要素核验）异常",
    "身份信息验证（二要素核验）通过"
  ]
};

@Component({})
export default class PaperResultReport extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => new CandidateNewResult() }) all!: CandidateNewResult;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;
  bgCheckList: any = [];

  @Watch("all")
  getAll(nval: CandidateNewResult) {
    this.getBgCheckList();
  }

  //
  mounted() {
    this.getBgCheckList();
  }

  showDetail(item: any) {
    return (
      (item.name !== "手机号实名认证" && item.type !== 2) ||
      (item.name === "手机号实名认证" && item.type === 0)
    );
  }

  getBgCheckList() {
    this.bgCheckList = [];
    this.all.report.errorInfoList.forEach(item => {
      if (cheatKeys.includes(item.task)) {
        this.bgCheckList.push({
          name: cheatEnum[item.task],
          type: item.result,
          task: item.task,
          result: errorEnumText[item.result],
          value:
            item.resMessage ||
            errorEnumTextEX?.[item.task]?.[item.result] ||
            errorEnumText[item.result]
        });
      }
    });
    this.$emit("getBgCheckList", this.bgCheckList);
  }

  async wait(secends: number) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true);
      }, secends);
    });
  }
}
